module.exports = __webpack_public_path__ + "img/appAsset-brand--Airtable.8144bef6.svg";